import { memo, useState } from "react";
import { useHusibuechContext } from "../../context/husibuechContext";
import MiddleBox from "../1_Boxes/MiddleBox";
import DeadlineAssignmentsList from "./DeadlineAssignmentsList";
import ReactCardFlip from "react-card-flip";
import { getBoxHeaderTitle } from "../../components/1_Boxes/getBoxHeaderTitle";
import BoxHeader from "../../components/1_Boxes/BoxHeader";

function DeadlineAssignmentsTFlip({ single }) {
  const {
    isAStudent,
    isATeacher,
    isAnAdmin,
    selectedCourse,
    showCourseAssignmentOnly,
  } = useHusibuechContext();
  const [teacherFlip, setTeacherFlip] = useState(true);

  const boxHeaderTitle = getBoxHeaderTitle(
    isAStudent,
    isATeacher,
    isAnAdmin,
    selectedCourse,
    teacherFlip ? "coreCourse" : "additional",
    showCourseAssignmentOnly,
  );

  // console.log("teacherFlip, ", teacherFlip)

  return (
    <ReactCardFlip isFlipped={teacherFlip} flipDirection="horizontal">
      <>
        <BoxHeader
          title={boxHeaderTitle}
          options={single ? [] : ["teacherFlip"]}
          flipTeacherAssignment={teacherFlip}
          setFlipTeacherAssignment={setTeacherFlip}
        />
        <MiddleBox>
          <DeadlineAssignmentsList type={"additional"} single={single} />
        </MiddleBox>
      </>
      <>
        <BoxHeader
          title={boxHeaderTitle}
          options={single ? ["courseView"] : ["courseView", "teacherFlip"]}
          flipTeacherAssignment={teacherFlip}
          setFlipTeacherAssignment={setTeacherFlip}
        />
        <MiddleBox>
          <DeadlineAssignmentsList type={"class"} />
        </MiddleBox>
      </>
    </ReactCardFlip>
  );
}

export default memo(DeadlineAssignmentsTFlip);
